/* eslint-disable no-plusplus */
import { PageItem } from '../types/PageItem';

export const buildPagination = (
  totalItems: number,
  itemsPerPage: number,
  currentPage: number,
  maxVisible = 3
): PageItem[] => {
  if (itemsPerPage <= 0) return ['prev', 1, 'next'];

  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const pages: PageItem[] = [];

  pages.push('prev');

  if (totalPages <= maxVisible + 2) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    const half = Math.floor(maxVisible / 2);
    let start = Math.max(2, currentPage - half);
    let end = Math.min(totalPages - 1, currentPage + half);

    if (currentPage <= half + 2) {
      start = 2;
      end = maxVisible + 1;
    }

    if (currentPage >= totalPages - (half + 1)) {
      start = totalPages - maxVisible;
      end = totalPages - 1;
    }

    pages.push(1);

    if (start > 2) pages.push('ellipsis');

    for (let i = start; i <= end; i++) pages.push(i);

    if (end < totalPages - 1) pages.push('ellipsis');

    pages.push(totalPages);
  }

  pages.push('next');

  return pages;
};
